/**
 * Whether the app is being served from the dev box (ADR 0020). The dev box and the live box run the same images, so the
 * address is the only honest signal. Everything else, a laptop's localhost included, is not the test server.
 */
export const isTestServer = (hostname: string): boolean => /^dev\./i.test(hostname.trim());

export const TEST_SERVER_LABEL = "Test server · not the live app";

/**
 * Says "test server" on every screen of dev.joogoos.com, the sign-in screen included, and nowhere else. Mounted beside
 * the app in `main.tsx`, so it does not depend on which screen is showing. Fixed and click-through: it never moves the
 * layout or catches a click meant for what is under it. Classes only, because the policy allows no inline style.
 */
export function TestServerBanner({ hostname = location.hostname }: { hostname?: string }) {
  if (!isTestServer(hostname)) return null;
  return (
    <div
      role="note"
      aria-label="This is the test server"
      className="pointer-events-none fixed bottom-3 left-1/2 z-50 -translate-x-1/2 rounded-full bg-coral px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-page shadow"
    >
      {TEST_SERVER_LABEL}
    </div>
  );
}
